import axios from "axios";
import NiceModal from "@ebay/nice-modal-react";
import { useContext } from "react";
import { RegionContext } from "providers/RegionProvider";

const clientKey = "test_ck_D5GePWvyJnrK0W0k6q8gLzN97Eoq";
// const https = require("https");

export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + Math.ceil(days * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  // document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Strict; Secure`;
  document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Strict;`;
};

export const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const [key, value] = cookies[i].split("=");
    if (key === name) {
      return value;
    }
  }

  return undefined;
};
export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict;`;
};

class MedusaRequester {
  instance = null;

  constructor() {
    axios.defaults.withCredentials = true;
    this.instance = axios.create({
      baseURL: `${process.env.REACT_APP_ORIGIN}/store`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      origin: `${process.env.REACT_APP_ORIGIN}`,
      // httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      withCredentials: true,
    });

    this.instance.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        if (
          error.response.status === 401 &&
          error.response.data === "Unauthorized"
        ) {
          // NiceModal.show("memberSignIn", { reload: true });
        }
        return Promise.reject(error);
      }
    );
    this.instance.interceptors.request.use(
      (config) => {
        const jwt = getCookie(Cookie.JWT);
        if (jwt) config.headers.Authorization = `Bearer ${jwt}`;
        return config;
      },
      async (error) => {
        return Promise.reject(error);
      }
    );
  }

  // setAuthTokenHeader(token) {
  //   this.instance = axios.create({
  //     baseURL: `${process.env.REACT_APP_ORIGIN}/store`,
  //     headers: {
  //       Accept: "application/json",
  //       "Content-Type": "application/json",
  //       Authorization: token,
  //     },
  //     origin: `${process.env.REACT_APP_ORIGIN}`,
  //     withCredentials: true,
  //   });
  // }

  async get(url, data) {
    let instance = this.instance;
    let result = "";
    let params = "?" + new URLSearchParams(data).toString();
    try {
      return new Promise(function(resolve, reject) {
        instance
          .get(url + params)
          // instance.get(url + params)
          .then((res) => {
            result = res.data;
          })
          .catch((error) => {
            if (error.response) {
              result = error.response.data;
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              // if (error.response.status === 401) {
              //   // invalid token
              //   result.code = error.response.status;
              // } else {
              // }
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            }
          })
          .finally(() => {
            resolve(result);
          });
      });
    } catch (e) {}
  }

  async post(url, data) {
    let instance = this.instance;
    let result = "";
    try {
      return new Promise(function(resolve, reject) {
        instance
          .post(url, JSON.stringify(data))
          .then((res) => {
            result = res.data;
          })
          .catch((error) => {
            if (error.response) {
              result = error.response.data;
              // if (error.response.status === 401) {
              //   // invalid token
              //   result.code = error.response.status;
              // } else {
              // }
            } else if (error.request) {
            } else {
            }
          })
          .finally(() => {
            resolve(result);
          });
      });
    } catch (e) {}
  }

  async delete(url, data) {
    let instance = this.instance;
    let result = "";
    let params = "?" + new URLSearchParams(data).toString();
    try {
      return new Promise(function(resolve, reject) {
        instance
          .delete(url + params)
          // instance.get(url + params)
          .then((res) => {
            result = res.data;
          })
          .catch((error) => {
            if (error.response) {
              result = error.response.data;
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              // if (error.response.status === 401) {
              //   // invalid token
              //   result.code = error.response.status;
              // } else {
              // }
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
            }
          })
          .finally(() => {
            resolve(result);
          });
      });
    } catch (e) {}
  }
  async Login(data, callback) {
    if (callback) callback(await this.post(`auth/token`, data));
    else return await this.post(`auth/token`, data);
  }
  async Logout(callback) {
    if (callback) callback(await this.delete(`auth`));
    else return await this.delete(`auth`);
  }
  async isExistEmail(email, callback) {
    if (callback) callback(await this.get(`/auth/${email}`));
    else return await this.get(`/auth/${email}`);
  }
  async createCustomer(data, callback) {
    if (callback) callback(await this.post(`/customers`, data));
    else return await this.post(`/customers`, data);
  }
  async updateCustomer(data, callback) {
    if (callback) callback(await this.post(`/customers/me`, data));
    else return await this.post(`/customers/me`, data);
  }
  async getCurrentCustomer(data, callback) {
    if (callback) callback(await this.get(`/customers/me`, data));
    else return await this.get(`/customers/me`, data);
  }
  async getCustomerOrders(data, callback) {
    if (callback) callback(await this.get(`/customers/me/orders`, data));
    else return await this.get(`/customers/me/orders`, data);
  }
  async cancelCustomerOrder(order_id, callback) {
    if (callback)
      callback(await this.post(`/customers/me/orders/${order_id}/cancel`));
    else return await this.post(`/customers/me/orders/${order_id}/cancel`);
  }
  async addShippingAddress(data, callback) {
    if (callback) callback(await this.post(`/customers/me/addresses`, data));
    else return await this.post(`/customers/me/addresses`, data);
  }
  async updateShippingAddress(address_id, data, callback) {
    if (callback)
      callback(await this.post(`/customers/me/addresses/${address_id}`, data));
    else return await this.post(`/customers/me/addresses/${address_id}`, data);
  }
  async deleteShippingAddress(address_id, callback) {
    if (callback)
      callback(await this.delete(`/customers/me/addresses/${address_id}`));
    else return await this.delete(`/customers/me/addresses/${address_id}`);
  }
  async getMyCart(region_id, callback) {
    const jwt = getCookie(Cookie.JWT);
    if (!jwt) return;
    const cartId = getCookie(Cookie.Cart);
    if (cartId) {
      const { cart } = await this.getCart(
        cartId,
        {
          expand:
            "items.variant.product.events,billing_address,shipping_address,shipping_methods",
        },
        callback
      );
      if (cart?.completed_at === null || cart?.completed_at === "null") {
        return { cart: cart };
      }
    }

    const { cart: beforeCart } = await this.getCustomerCart({
      completed_at: null,
    });
    if (beforeCart) {
      setCookie(Cookie.Cart, beforeCart.id, 1);
      return { cart: beforeCart };
    }
    if (!region_id) return null;
    const { cart } = await this.createCart({ region_id: region_id });
    setCookie(Cookie.Cart, cart.id, 1);
    return { cart: cart };
  }
  async getCustomerCart(data, callback) {
    if (callback) callback(await this.get(`/customers/me/carts`, data));
    else return await this.get(`/customers/me/carts`, data);
  }
  async getCart(id, data, callback) {
    if (callback) callback(await this.get(`/carts/${id}`, data));
    else return await this.get(`/carts/${id}`, data);
  }
  async createCart(data, callback) {
    if (callback) callback(await this.post(`/carts`), data);
    else return await this.post(`/carts`, data);
  }
  async updateCart(cartId, data, callback) {
    if (callback) callback(await this.post(`/carts/${cartId}`), data);
    else return await this.post(`/carts/${cartId}`, data);
  }
  async addItem(cartId, data, callback) {
    if (callback) callback(await this.post(`carts/${cartId}/line-items`, data));
    else return await this.post(`carts/${cartId}/line-items`, data);
  }
  async updateItem(cartId, itemId, data, callback) {
    if (callback)
      callback(await this.post(`carts/${cartId}/line-items/${itemId}`, data));
    else return await this.post(`carts/${cartId}/line-items/${itemId}`, data);
  }
  async removeItem(cartId, itemId, callback) {
    if (callback)
      callback(await this.delete(`carts/${cartId}/line-items/${itemId}`));
    else return await this.delete(`carts/${cartId}/line-items/${itemId}`);
  }
  async createPaymentSession(cartId, callback) {
    if (callback) callback(await this.post(`carts/${cartId}/payment-sessions`));
    else return await this.post(`carts/${cartId}/payment-sessions`);
  }
  async placeOrder(cartId, callback) {
    if (callback) callback(await this.post(`carts/${cartId}/complete`));
    else return await this.post(`carts/${cartId}/complete`);
  }
  async addShipoingMethod(cartId, data, callback) {
    if (callback)
      callback(await this.post(`carts/${cartId}/shipping-methods`, data));
    else return await this.post(`carts/${cartId}/shipping-methods`, data);
  }
  async updateOrder(orderId, data, callback) {
    if (callback) callback(await this.post(`orders/${orderId}`, data));
    else return await this.post(`orders/${orderId}`, data);
  }
  async getRegions(callback) {
    if (callback) callback(await this.get(`/regions`));
    else return await this.get(`/regions`);
  }

  async deleteWish(data, callback) {
    if (callback) callback(await this.delete(`/interests`, data));
    else return await this.delete(`/interests`, data);
  }

  async getEvents(data, callback) {
    if (callback) callback(await this.get(`/events`, data));
    else return await this.get(`/events`, data);
  }

  async getProducts(data, callback) {
    if (callback) callback(await this.get(`/products`, data));
    else return await this.get(`/products`, data);
  }
  async getProduct(id, data, callback) {
    if (callback) callback(await this.get(`/products/${id}`, data));
    else return await this.get(`/products/${id}`, data);
  }
  async getVariantsStatus(data, callback) {
    if (callback) callback(await this.get(`/variants/status`, data));
    else return await this.get(`/variants/status`, data);
  }
  async getVariants(data, callback) {
    if (callback) callback(await this.get(`/variants`, data));
    else return await this.get(`/variants`, data);
  }
  async getVariant(id, data, callback) {
    if (callback) callback(await this.get(`/variants/${id}`, data));
    else return await this.get(`/variants/${id}`, data);
  }
  async getDiscounts(data, callback) {
    if (callback) callback(await this.get(`/discounts`, data));
    else return await this.get(`/discounts`, data);
  }
  async getArticle(data, callback) {
    if (callback) callback(await this.get(`/articles`, data));
    else return await this.get(`/articles`, data);
  }
  async getShippingOptions(data, callback) {
    if (callback) callback(await this.get(`/shipping-options`, data));
    else return await this.get(`/shipping-options`, data);
  }
  async getVaraint(id, data, callback) {
    if (callback) callback(await this.get(`/variants/${id}`, data));
    else return await this.get(`/variants/${id}`, data);
  }
  async getInterest(callback) {
    if (callback) callback(await this.get(`/customers/me/interests`));
    else return await this.get(`/customers/me/interests`);
  }
  async postInterest(data, callback) {
    // {"product_id":"상품아이디"}
    if (callback) callback(await this.post(`/customers/me/interests`, data));
    else return await this.post(`/customers/me/interests`, data);
  }
  async deleteInterest(id, callback) {
    if (callback) callback(await this.delete(`/customers/me/interests/${id}`));
    else return await this.delete(`/customers/me/interests/${id}`);
  }
}
export const Cookie = {
  JWT: "_medusa_jwt",
  Cart: "_medusa_cart_id",
};
export default MedusaRequester;
